// extracted by mini-css-extract-plugin
export var links = "PreFooter-module--links--726c1";
export var preFooterWrapper = "PreFooter-module--preFooterWrapper--3cf67";
export var text = "PreFooter-module--text--da8fe";